export default function toFieldProps(field) {
  const fieldProps = { ...field };
  delete fieldProps.error;
  delete fieldProps.isReady;
  delete fieldProps.isActive;
  fieldProps.checked = !!fieldProps.checked;

  return fieldProps;
}
